import React from 'react';
import {
    transactionTitleStyle,
    accountNameStyle
} from './BillingStyles';
import { IconClose } from '@adserve/adserve-react-components';

const ForwardScheduleSourceHeader = ({
    item,
    sourceName,
    title,
    setShowForwardScheduleDetails
}) => {
    const handleBackClick = () => {
        setShowForwardScheduleDetails(false);
    };

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: -12,
                    marginRight: 12
                }}
            >
                <div onClick={handleBackClick} style={{ cursor: 'pointer' }}>
                    <IconClose height={19} width={19} />
                </div>
            </div>

            <div>
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        marginLeft: 13,
                        paddingTop: 5
                    }}
                >
                    <span style={accountNameStyle}>{sourceName}</span>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                        alignItems: 'flex-end',
                        justifyContent: 'flex-end',
                        marginRight: 11
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            paddingTop: 20,
                            height: 1
                        }}
                    >
                    </div>
                </div>
            </div>
            <div>
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        marginLeft: 13,
                        paddingTop: 5
                    }}
                >
                    <span style={transactionTitleStyle}>
                        {title}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ForwardScheduleSourceHeader;
